var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntegratedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 6",
    id: "Layer_6",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8,2H8A1,1,0,0,1,9,3V9A0,0,0,0,1,9,9H7A0,0,0,0,1,7,9V3A1,1,0,0,1,8,2Z",
    style: {
      fill: "#738394"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,2h0a1,1,0,0,1,1,1V9a0,0,0,0,1,0,0H15a0,0,0,0,1,0,0V3a1,1,0,0,1,1-1Z",
    style: {
      fill: "#738394"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,8v6.5a2.99985,2.99985,0,0,0,1.2,2.4L9,19v3h6V19l2.8-2.1A2.99985,2.99985,0,0,0,19,14.5V8Z",
    style: {
      fill: "#67c7a5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.256 16.478 8.27 13.48 9.684 12.066 11.256 13.638 14.478 10.416 15.892 11.83 11.256 16.478",
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegratedIcon);
export default __webpack_public_path__ + "static/media/integratedIcon.f18fdf50.svg";
export { ForwardRef as ReactComponent };